// Bottom Donate Section
const BottomDonateSection = () => {
  return (
    <section 
      data-testid="bottom-donate-section"
      className="pb-8 px-4 md:px-8 lg:px-12 bg-[#FAFAFA]"
    >
      <div className="max-w-4xl mx-auto text-center">
        <a
          href="https://www.zeffy.com/en-US/donation-form/d4b70ccf-7c7a-43d8-a48e-1328d3056f49"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="bottom-donate-btn"
          className="inline-block bg-[#C41E3A] hover:bg-[#a31830] text-white text-lg font-semibold px-10 py-4 rounded-full transition-all duration-200 hover:scale-105 shadow-lg"
        >
          Donate
        </a>
      </div>
    </section>
  );
};

export default BottomDonateSection;
